// extracted by mini-css-extract-plugin
module.exports = {"posts_wrapper":"forum_main_posts_wrapper__3mk5D","other_posts_wrapper":"forum_main_other_posts_wrapper__Vyr0t"};